import { spacing, tokens } from '@urbanx/agx.ui-components2/tokens';
import { style } from '@vanilla-extract/css';

export const wrapper = style({
  maxWidth: '100%',
  selectors: {
    // Let destination labels wrap beyond the shared medium button's height cap.
    '&&': { maxHeight: 'none' },
  },
});

export const backButton = style({
  maxWidth: '100%',
  selectors: {
    '&#btn-back:hover': {
      textDecoration: 'none',
    },
    '&#btn-back:focus-visible': {
      outline: `2px solid ${tokens.border.primary}`,
      outlineOffset: spacing.xs,
    },
  },
});
